export const getSomeDaysAgo = (day: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() - day + 1);
  return date;
};

export const getThisMonth = () => {
  const firstDate = new Date();
  firstDate.setDate(1);
  firstDate.setMonth(firstDate.getMonth());
  const lastDate = new Date();
  return {
    start: firstDate,
    end: lastDate,
  };
};

export const getLastSomeMonths = (month: number) => {
  const firstDate = new Date();
  firstDate.setDate(1);
  firstDate.setMonth(firstDate.getMonth() - month);
  const lastDate = new Date();
  lastDate.setDate(0);
  return {
    start: firstDate,
    end: lastDate,
  };
};

export const getDayBetween = (start: string, end: string) => {
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();
  return Math.round((endTime - startTime) / (1000 * 60 * 60 * 24));
};

export const addHourQuantity = (hour: number) => new Date(new Date().getTime() + hour * 60 * 60 * 1000);
export const addMinuteQuantity = (minutes: number) => new Date(new Date().getTime() + minutes * 60 * 1000);


export function getFirstDayOfNextMonth(currentDate?: Date): Date {
  const date = currentDate ? new Date(currentDate) : new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const nextMonth = new Date(year, month + 1, 1);
  return nextMonth;
}

/**
 * Convert UTC hour string to local timezone
 * @param utcTimeString - Time string in format "HH:MM" (e.g., "00:59", "01:59")
 * @returns Local time string in format "HH:MM"
 */
export const convertUtcHourToLocalTimezone = (utcTimeString: string): string => {
  const timeMatch = utcTimeString.match(/^(\d{2}):(\d{2})$/);
  if (!timeMatch) {
    return utcTimeString;
  }

  const utcHour = parseInt(timeMatch[1], 10);
  const utcMinute = parseInt(timeMatch[2], 10);

  // Create a UTC date with the given hour
  const utcDate = new Date();
  utcDate.setUTCHours(utcHour, utcMinute, 0, 0);

  // Get local hour
  const localHour = utcDate.getHours();
  const localMinute = utcDate.getMinutes();

  // Format to HH:MM
  const formattedHour = localHour.toString().padStart(2, '0');
  const formattedMinute = localMinute.toString().padStart(2, '0');

  return `${formattedHour}:${formattedMinute}`;
};

/**
 * Format time string as hour range without conversion
 * @param timeString - Time string in format "HH:MM"
 * @returns Formatted range like "07:00-07:59"
 */
export const formatTimeAsHourRange = (timeString: string): string => {
  const timeMatch = timeString.match(/^(\d{2}):(\d{2})$/);
  if (timeMatch) {
    const hour = timeMatch[1];
    return `${hour}:00-${hour}:59`;
  }
  return timeString;
};

/**
 * Format tooltip title for time ranges (for already converted local time)
 * Only formats as range, does not convert timezone
 * @param title - Time string or category name (already in local time)
 * @returns Formatted range title
 */
export const formatAnalyticsTooltipTitle = (title: string): string => {
  // Check if title matches time format like "00:59", "01:30", etc.
  const timeMatch = title.match(/^(\d{2}):(\d{2})$/);
  if (timeMatch) {
    return formatTimeAsHourRange(title);
  }
  return title;
};

/**
 * Format tooltip title for time ranges from UTC time
 * Converts UTC time to local timezone and formats as range
 * @param title - Time string or category name (in UTC)
 * @returns Formatted title in local timezone
 */
export const formatAnalyticsTooltipTitleFromUtc = (title: string): string => {
  // Check if title matches time format like "00:59", "01:30", etc.
  const timeMatch = title.match(/^(\d{2}):(\d{2})$/);
  if (timeMatch) {
    const localTime = convertUtcHourToLocalTimezone(title);
    return formatTimeAsHourRange(localTime);
  }
  return title;
};